// Interval checking only for the specific elements needed by getActiveUiGroupUrl and setupFilterButton
function initFilter() {
    const interval = setInterval(() => {
        if (document.querySelector('.sk-tab--selected') &&
            (document.querySelector('#RMPoolUIDefinition-FieldsetGroup-Filtering-action-button-1') || 
             document.querySelector('#AdminPoolProcess1UI1-FieldsetGroup1-Filtering-action-button-1'))) {
            getActiveUiGroupUrl();
            setupFilterButton();
    
            clearInterval(interval); // Stop interval once actions are performed
        }
    }, 500);
    
    // Safety timeout to clear interval after 5 seconds
    setTimeout(() => {
        clearInterval(interval);
    }, 5000);
}

function getActiveUiGroupUrl() {
    const selectedTab = document.querySelector('.sk-tab--selected');
    
    const tabMappings = {
        'sk-tab-RMPoolUIDefinition-FieldsetGroup-NewAutoSearch-TabGroup1-MotorAutoSearch': 'MotorAutoSearch',
        'sk-tab-RMPoolUIDefinition-FieldsetGroup-NewAutoSearch-TabGroup1-TravelAutoSearch': 'TravelAutoSearch',
        'sk-tab-RMPoolUIDefinition-FieldsetGroup-NewAutoSearch-TabGroup1-HomeAutoSearch': 'HomeAutoSearch',
        'sk-tab-AdminPoolProcess1UI1-FieldsetGroup2-NewAutoSearch-TabGroup1-MotorAutoSearch': 'MotorAutoSearch',
        'sk-tab-AdminPoolProcess1UI1-FieldsetGroup2-NewAutoSearch-TabGroup1-TravelAutoSearch': 'TravelAutoSearch',
        'sk-tab-AdminPoolProcess1UI1-FieldsetGroup2-NewAutoSearch-TabGroup1-HomeAutoSearch': 'HomeAutoSearch'
    };

    if (selectedTab && tabMappings[selectedTab.id]) {
        const activeUiGroup = tabMappings[selectedTab.id];
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('activeUiGroup', activeUiGroup);

        return currentUrl.href;
    }
    return window.location.href;
}

function setupFilterButton() {
    const filterButton = document.querySelector('#RMPoolUIDefinition-FieldsetGroup-Filtering-action-button-1') || 
                         document.querySelector('#AdminPoolProcess1UI1-FieldsetGroup1-Filtering-action-button-1');
    
    if (filterButton) {
        filterButton.addEventListener('click', function(event) {
            event.preventDefault();
            const newUrl = getActiveUiGroupUrl();
            window.location.href = newUrl;
        });
    }
}

export { initFilter }